
export default function Footer() {
  const quickLinks = [
    { name: '产品中心', href: '#products' },
    { name: '科学研究', href: '#science' },
    { name: '关于我们', href: '/about' },
    { name: '社群计划', href: '#community' }
  ];

  const socialLinks = [
    { name: '微信', icon: 'ri-wechat-fill', href: '#' },
    { name: '微博', icon: 'ri-weibo-fill', href: '#' },
    { name: '小红书', icon: 'ri-book-mark-fill', href: '#' },
    { name: '抖音', icon: 'ri-tiktok-fill', href: '#' }
  ];

  const handleLinkClick = (href: string) => {
    if (href.startsWith('#')) {
      // 页面内锚点跳转
      const element = document.querySelector(href);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      // 页面跳转
      window.REACT_APP_NAVIGATE(href);
      // 跳转后滚动到顶部
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 100);
    }
  };

  return (
    <footer id="contact" className="bg-gray-50 py-12 lg:py-16">
      <div className="max-w-7xl mx-auto px-6 lg:px-32">
        <div className="grid md:grid-cols-4 gap-8 lg:gap-12">
          {/* 品牌信息 */}
          <div className="md:col-span-2">
            <img 
              src="https://static.readdy.ai/image/2e1ac11483faca2c19cd44d7d582b015/58ab3c2c100cfeefc13e4dde60a3c9a8.png"
              alt="燃轻元"
              className="h-8 lg:h-10 w-auto object-contain mb-3 lg:mb-4"
            />
            <p className="text-xs lg:text-base text-gray-600 font-light leading-relaxed mb-4 lg:mb-6 max-w-md">
              轻松一点，才轻一点。通过科学、有趣、无压力的产品与体验，帮助用户从内到外获得身体的轻盈和心理的轻松。
            </p>
            <div className="flex space-x-3 lg:space-x-4">
              {socialLinks.map((social) => (
                <a
                  key={social.name}
                  href={social.href}
                  className="w-8 lg:w-10 h-8 lg:h-10 bg-white rounded-full flex items-center justify-center text-[#847eba] hover:bg-[#847eba] hover:text-white transition-all duration-300 shadow-sm cursor-pointer"
                  title={social.name}
                >
                  <i className={`${social.icon} text-sm lg:text-lg`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* 快速链接 */}
          <div>
            <h4 className="text-sm lg:text-base font-medium text-gray-800 mb-4 lg:mb-6">快速链接</h4>
            <ul className="space-y-2 lg:space-y-3">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <button
                    onClick={() => handleLinkClick(link.href)}
                    className="text-xs lg:text-base text-gray-600 hover:text-[#847eba] transition-colors duration-300 font-light cursor-pointer text-left"
                  >
                    {link.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* 联系信息 */}
          <div>
            <h4 className="text-sm lg:text-base font-medium text-gray-800 mb-4 lg:mb-6">联系我们</h4>
            <div className="space-y-2 lg:space-y-3">
              <div className="flex items-center text-gray-600">
                <i className="ri-mail-line mr-2 lg:mr-3 text-[#847eba] text-sm lg:text-base"></i>
                <span className="font-light text-xs lg:text-base">hello@ranqingyuan.com</span>
              </div>
              <div className="flex items-center text-gray-600">
                <i className="ri-phone-line mr-2 lg:mr-3 text-[#847eba] text-sm lg:text-base"></i>
                <span className="font-light text-xs lg:text-base">400-888-9999</span>
              </div>
              <div className="flex items-start text-gray-600">
                <i className="ri-map-pin-line mr-2 lg:mr-3 text-[#847eba] mt-1 text-sm lg:text-base"></i>
                <span className="font-light text-xs lg:text-base">北京市朝阳区科技园区创新大厦</span>
              </div>
            </div>
          </div>
        </div>

        {/* 分割线 */}
        <div className="border-t border-gray-200 mt-8 lg:mt-12 pt-6 lg:pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-gray-500 text-xs lg:text-sm font-light">
              © 2024 燃轻元. 保留所有权利.
            </div>
            
            {/* 快速链接列表 */}
            <div className="flex flex-wrap items-center gap-4 lg:gap-6 text-xs lg:text-sm">
              <a href="#" className="text-gray-500 hover:text-[#847eba] transition-colors duration-300 cursor-pointer">
                隐私政策
              </a>
              <a href="#" className="text-gray-500 hover:text-[#847eba] transition-colors duration-300 cursor-pointer">
                服务条款
              </a>
              <a href="https://readdy.ai/?origin=logo" className="text-gray-500 hover:text-[#847eba] transition-colors duration-300 cursor-pointer">
                Made with Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
